import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.coupons.edit', []).controller('CouponsEditCtrl', CouponsEditCtrl)

/** @ngInject */
function CouponsEditCtrl(
  $state,
  $scope,
  $rootScope,
  $stateParams,
  $timeout,
  CouponsService,
  UploadService,
) {
  var vm = this
  vm.model = {}
  vm.id = parseInt($stateParams.id)
  vm.isOpen1 = false
  vm.isOpen2 = false
  vm.dur = null

  vm.creditTypes = [
    {
      id: 1,
      name: 'Primary Market',
    },
    {
      id: 2,
      name: 'Aftermarket',
    },
  ]

  vm.openCalendar1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen1 = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.portionTime = function (durationInSeconds) {
    if (!durationInSeconds) return '-'
    var tempTime = moment.duration(durationInSeconds / 1000000).humanize()
    return tempTime
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  $('#modalCoupon').on('shown.bs.modal', function () {
    var rcId = localStorage.getItem('reward_coupon_id')
    vm.pathImg = null
    vm.loadImg = false
    vm.data1 = null
    vm.data2 = null
    vm.dur = null
    vm.model = {}
    if (rcId) {
      vm.id = parseInt(localStorage.getItem('reward_coupon_id'))
      load()
    }
  })

  // $("#modalCoupon").on("hidden.bs.modal", function () {
  //   console.log("oi3");

  //   $("body").addClass("modal-open");
  // });

  var whichPage = window.location.pathname
  vm.isRewardPageOrChecklistPage =
    whichPage.indexOf('checklist') !== -1 || whichPage.indexOf('rewards') !== -1

  if (!vm.isRewardPageOrChecklistPage) {
    load()
  }

  vm.isPromoPage = false
  $rootScope.$on('modalNewCoupon', function (event, id) {
    if (whichPage.indexOf('promo_campaigns') !== -1) {
      vm.model = {}
      vm.isPromoPage = true
      vm.pathImg = null
      vm.loadImg = false
      vm.data1 = null
      vm.data2 = null
      vm.dur = null
      load()
    }
  })

  function load() {
    if (vm.id !== 0) {
      CouponsService.get(vm.id).then(function (result) {
        vm.model = result.results
        if (vm.model['ts-x']) {
          vm.model['ts-x'] = new Date(parseInt(vm.model['ts-x'] / 1000))
          vm.data1 = angular.copy(vm.model['ts-x'])
        }
        if (vm.model['ts-start']) {
          vm.model['ts-start'] = new Date(parseInt(vm.model['ts-start'] / 1000))
          vm.data2 = angular.copy(vm.model['ts-start'])
        }
      })
    }
  }

  vm.applyDur = function () {
    switch (vm.durValue) {
      case 'hour':
        // convert duration to hour
        vm.model.dur = vm.dur * 60 * 60 * 1000000000
        break
      case 'day':
        // convert duration to day
        vm.model.dur = vm.dur * 60 * 60 * 24 * 1000000000
        break
      case 'week':
        // convert duration to week
        vm.model.dur = vm.dur * 60 * 60 * 24 * 7 * 1000000000
        break
    }
  }

  vm.save = function () {
    var model = angular.copy(vm.model)

    if (vm.data1) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-x'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-x'] = null
    }

    if (vm.data2) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-start'] = null
    }

    if (!model.dur || model.dur === 0) {
      delete model.dur
    }

    if (model.id) {
      CouponsService.update(model.id, model).then(function () {
        if (vm.isPromoPage || vm.isRewardPageOrChecklistPage) {
          CouponsService.publish(model.id).then(function () {
            if (!vm.isPromoPage) {
              localStorage.setItem('reward_coupon_id', model.id)
              $timeout(function () {
                if (localStorage.getItem('reward_coupon_id')) {
                  $('#modalCoupon').modal('hide')
                } else {
                  $state.go('admin.coupons')
                }
              }, 250)
            } else {
              localStorage.setItem('promo_coupon_id', model.id)
              $timeout(function () {
                if (localStorage.getItem('promo_coupon_id')) {
                  $('#modalNewCoupon').modal('hide')
                } else {
                  $state.go('admin.coupons')
                }
              }, 250)
            }
          })
        } else {
          $state.go('admin.coupons')
        }
      })
    } else {
      CouponsService.save(model).then(function (res) {
        if (vm.isPromoPage || vm.isRewardPageOrChecklistPage) {
          CouponsService.publish(res.results.id).then(function () {
            if (!vm.isPromoPage) {
              localStorage.setItem('reward_coupon_id', res.results.id)
              $timeout(function () {
                if (localStorage.getItem('reward_coupon_id')) {
                  $('#modalCoupon').modal('hide')
                } else {
                  $state.go('admin.coupons')
                }
              }, 250)
            } else {
              localStorage.setItem('promo_coupon_id', res.results.id)
              $timeout(function () {
                if (localStorage.getItem('promo_coupon_id')) {
                  $('#modalNewCoupon').modal('hide')
                } else {
                  $state.go('admin.coupons')
                }
              }, 250)
            }
          })
        } else {
          $state.go('admin.coupons')
        }
      })
    }
  }

  vm.cancel = function () {
    if (localStorage.getItem('reward_coupon_id')) {
      $('#modalCoupon').modal('hide')
      $timeout(function () {
        $('body').addClass('modal-open')
      }, 500)
    } else if (localStorage.getItem('promo_coupon_id')) {
      $('#modalNewCoupon').modal('hide')
      $timeout(function () {
        $('body').addClass('modal-open')
      }, 500)
    } else {
      $state.go('admin.coupons')
    }
  }

  vm.loadImg = false
  vm.uploadImg = function (item) {
    vm.loadImg = true
    var id = 0
    if (item.id) {
      id = item.id
    }
    UploadService.save('coupons', vm.pathImg, 'img', id).then(function (fileName) {
      vm.loadImg = false
      item.img = fileName
    })
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })
}
